import { render, staticRenderFns } from "./AddMain.vue?vue&type=template&id=467378c4"
import script from "./AddMain.vue?vue&type=script&lang=js"
export * from "./AddMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports